import env from "../env.json";

export const BASE_URL = env.API_HOST_NAME;
export const RECEIPT_BASE_URL = env.E_RECEIPT;
export const GOOGLE_API = env.GOOGLE_MAPS_API_KEY;
export const DASHBOARD_BASE_URL = env.API;
export const PAYMENT_URL = env.PAYMENT_URL;
export const IMG_URL = env.CYNTRA_S3_IMG_URL;
export const VIDEO_BASE_URL = env.CYNTRA_S3_IMG_URL;
export const STORE_FB ="F&B";


//******* NRF URLs*/
export const NRF_REGISTRATION = BASE_URL + "/customer/nrf-user-registration";

//******* AAhar URLs*/
export const AAHAR_REGISTRATION = BASE_URL + "/customer/aahar-user-registration";

export const SEND_EMAIL= BASE_URL + "/auth/send-email";

//******* Feedback URLs*/
export const SUBMIT_FEEDBACK = BASE_URL + "/store/submit-feedback";
export const FEEDBACK_BRANDING = BASE_URL + "/store/feedback ";


//******* Inventory URLs*/
export const LOGIN = BASE_URL + "/auth/web-login";

//******* Inventory URLs*/
export const CATEGORY_URL = BASE_URL + "/category-search-flat/get";
export const ALL_ITEMS = BASE_URL + "/item-search-flat/get";
export const ALL_ADDON = BASE_URL + "/inventory/addon-list";
export const INVENTORY_URL = BASE_URL + "/inventory/item-inventory";
export const FOOD_INVENTORY_URL = BASE_URL + "/inventory/food-item-inventory";

//******* Transaction URLs*/
export const TENDER = BASE_URL + "/transaction/tenders";
export const LAST_ORDER = BASE_URL + "/transaction/last-order-no";
export const PLACE_ORDER_URL = BASE_URL + "/transaction/v2/order-place";
export const CREATE_ORDER_URL = BASE_URL + "/transaction/v2/save-order";
export const CHECK_INVENTORY_STOCK = BASE_URL + "/transaction/check-inventory-stock";
export const UPDATE_ORDER_STATUS =
  BASE_URL + "/transaction/update-payment-status";
export const UPDATE_ORDER =
  BASE_URL + "/transaction/v2/update-order";
//******* Payment URLs*/
export const PAYTM_INI_PAYMENT = BASE_URL + "/paytm/initiate-transaction";
export const REZORPAY_INI_PAYMENT = BASE_URL + "/rezorpay/initiate-transaction";
export const PAYMENTS_PAY = BASE_URL + "/payments/pay";
export const PAYMENTS_STATUS = BASE_URL + "/payments/status";
export const ACK_PAGE_URL = env.ACK_PAGE_URL;

//******* Customer URLs*/
export const CUSTOMER = BASE_URL + "/customer/customer";
export const CUSTOMER_SAVE = BASE_URL + "/customer/save";
export const REMOVE_CUSTOMER_ADDRESS = BASE_URL + "/customer/remove-customer-address";
export const CUSTOMER_MEMBERSHIP_PLAN = BASE_URL + "/customer/membership-plan";

//******* OFFERS URLs*/
export const OFFERS = BASE_URL + "/offer/list";


//******* CHARGES URLs*/
export const CHARGES = BASE_URL + "/store/order-level-charges";


//******* Store URLs*/
export const STORE = BASE_URL + "/store/details";
export const ASSOCIATED_STORE = BASE_URL + "/store/associated-store";

//******* Order Type URLs*/
export const GET_ORDER_TYPE = BASE_URL + "/transaction/order-type";
export const GET_TABLE_ORDERS = BASE_URL + "/transaction/get-table-orders";

//******* Item Label URLs*/
export const GET_LABEL_TYPE = BASE_URL + "/inventory/all-item-label";

//******* WHATSAPP OTP & ORDER URLs

// export const REGISTER_CUSTOMER_OTP = BASE_URL + "/whatsapp/otp";
export const CUSTOMER_ORDER = BASE_URL + "/whatsapp/order";
// SMS URL
export const REGISTER_CUSTOMER_OTP = BASE_URL + "/otp-sms";

//order SMS url
export const SEND_ORDER_RECEIPT = BASE_URL + "/transaction/send-order-receipt";

//*******  Banner URLs*/
export const GET_BANNER_DETAILS = BASE_URL + "/inventory/get-banner-details";
export const QR_DETAILS_URL = BASE_URL + "/store/qr-details";

export const ASSOCIATED_STORES = "ASSOCIATED_STORES";
export const CART_DATA = "CART_DATA";
export const CUSTOMER_DATA = "CUSTOMER_DATA";
export const LAST_ORDER_DATA = "LAST_ORDER_DATA";
export const ORDER_TYPE = "ORDER_TYPE";
export const REQUEST_ORDER = "REQUEST_ORDER";
export const ITEM_LIST = "ITEM_LIST";
export const STORE_TALBE_LIST = "STORE_TALBE_LIST";
export const SET_TENDER = "SET_TENDER";
export const SET_CHARGES = "SET_CHARGES";
export const APPLIED_OFFERS = "APPLIED_OFFERS";
export const OPEN_ORDER = "OPEN_ORDER";
export const STORE_DETAILS = "STORE_DETAILS";
export const STORE_CONFIG = "STORE_CONFIG";
export const STORE_OFFERS = "STORE_OFFERS";
export const USER_DATA = "USER_DATA";
export const ORDER_DETAILS = "ORDER_DETAILS";
export const LAST_ORDER_LIST = "LAST_ORDER_LIST";
export const CAPTURED_IMAGE = "CAPTURED_IMAGE";
export const APPLIED_FILTERS = "APPLIED_FILTERS";
export const PROFILE_IMG_URL = "PROFILE_IMG_URL";
export const SAVE_SHARE_IMAGE = "SAVE_SHARE_IMAGE";
export const SEND_BUZZR_NOTIFICATION = "SEND_BUZZR_NOTIFICATION";
export const GET_USER_DETAILS = "GET_USER_DETAILS";
export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
export const GET_LAST_ORDER_DETAILS = "GET_LAST_ORDER_DETAILS";
export const CAMERA_IMG_URL = "CAMERA_IMG_URL";

export const TOKEN_KEY = "jwt";
export const CGST = 2.5;
export const SGST = 2.5;

export const MinHour = env.OPENING_TIME;
export const MaxHour = env.CLOSING_TIME;
export const SESSION_TIME = 1000 * 60 * (env.SESSION_TIME || 30);

//****** Chat Constant */
export const CHAT = "CHAT";
//export const TOKEN_KEY = 'TOKEN_KEY';
export const NEW_CHAT_MESSAGE_EVENT = "newChatMessage";
export const ACTIVE_USERS = "activeUsers";
export const SEEN_BY_RECIPIENT = "seenByRecipient";
export const GET_ONLINE_USERS = "getOnlineUsers";
export const SOCKET_SERVER_URL = env.SOCKET_SERVER_URL;

//VALUE CONSTANTS

// const storeDetail = localStorage.getItem("STORE_DETAILS");
// let Store = null;
// if (storeDetail) {
//   console.log(JSON.parse(storeDetail));
//   Store = JSON.parse(storeDetail);
// }

export const BUTTON_COLOR = "Black";
export const HEADER_COLOR = "Black";
export const CATEGORY_COLOR = "Black";
export const MENU_HEADER_COLOR = "Black";
export const OFFER_COLOR = "Black";
export const APP_BAR_COLOR = "Black";

export const BACKGROUND_COLOR = "#272727";
export const TEXT_COLOR = "White";

export const Constant = {
  currencySign: "R",
  storeName: "The Barcode",
  proceedText: "Proceed",
  cancelText: "Cancel Order",
  HomeBtn: "Home",
  OrderStatus: {
    accept: 1,
    ready: 2,
    readyTopay: 3,
    cancel: 4,
    paid: 5,
    refund: 6,
  },
  OrderType: {
    dine: 0,
    takeaway: 1,
    delivery: 2,
    pickup: 3,
  },
  PaymentMode: {
    Cash: 1,
    Card: 2,
    online: 3,
  },
  OrderTypeEnum: {
    Self_Pickup: "SELF",
    At_Table: "TABLE",
  },
};

export const ORDER_CODE = {
  DINE_IN: "DI",
  TAKE_AWAY: "TA",
  DELIVERY: "DEL",
};

export const PAYMENT_STATE = {
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  PENDING: "PENDING",
};
